import { SharingMinistryType } from "../types/supabase"

/**
 * Terminology that varies between sharing ministries. Sedera and Samaritan
 * (SMI) members refer to what CHM members call an "incident" as a "need". The
 * four casing variants cover the places where these words appear in UI copy
 * and TODO titles.
 */
export interface Terminology {
  incident: string
  Incident: string
  incidents: string
  Incidents: string
}

const NEED_TERMINOLOGY: Terminology = {
  incident: 'need',
  Incident: 'Need',
  incidents: 'needs',
  Incidents: 'Needs',
}

const DEFAULT_TERMINOLOGY: Terminology = {
  incident: 'incident',
  Incident: 'Incident',
  incidents: 'incidents',
  Incidents: 'Incidents',
}

export function getTerminology(sharingMinistry: SharingMinistryType | null | undefined): Terminology {
  return sharingMinistry === 'Sedera' || sharingMinistry === 'SMI' ? NEED_TERMINOLOGY : DEFAULT_TERMINOLOGY
}
